import { render, staticRenderFns } from "./PriceMixes.vue?vue&type=template&id=7fdffe14&"
import script from "./PriceMixes.vue?vue&type=script&lang=js&"
export * from "./PriceMixes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports